import React from 'react';
import styled from 'styled-components';
import { media } from './media-query'

export default class Alert extends React.Component {
    constructor() {
        super();
        this.state = {
            show: true
        }
    }
    render() {
        return (
            <AlertWrapper show={this.state.show}>
                <div>
                    <span className="close" onClick={()=>{ console.log('click'); this.setState({show: false})}}>X</span>
                    <img src="/img/alert.gif" alt=""/>
                    <h2>SVINDLERE UDGIVER SIG FOR <br />AT VÆRE OS!</h2>
                    <p>
                        Kære besøgende, <br />
                        Vi er blevet opmærksomme på, at svindlere udgiver sig for at være os i forsøg på at låne penge eller købe på kredit. Såfremt du modtager en sådan henvendelse, råder vi på det kraftigste til at afvise denne.
                        <br /><br />
                        Modtager du en sådan henvendelse hører vi gerne fra dig. Sagen er meldt til politiet<br />
                    </p>
                </div>
            </AlertWrapper>
        )
    }
}

const AlertWrapper = styled.div`
display: ${props=> props.show===true ? "block" : "none"};
position: absolute;
padding: 50px;
top: 50%;
left: 40px;
transform: translateY(-50%) ;
z-index: 20;
img {
    width: 50px;
}
border: 2px solid #000000;
width: 500px;
text-align: center;
background-color: #ffffff;

.close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
    font-weight: 800;
    cursor: pointer;
}

${media.phone`
    width: 90%;
    left: 50%;
    top: 50%;
    transform: translateY(-50%) translateX(-50%);
    z-index: 100;
`};
`


// WEBPACK FOOTER //
// ./src/components/alert.js